(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ferdora-withdrawal"] && !Shopify.designMode) return;
  try {
    
const root=document.querySelector('.fd-withdrawal');
if(root){
 const form=root.querySelector('#FerdoraWithdrawal');
 const success=root.querySelector('[data-fd-success]');
 const key='ferdora-withdrawal-pending';
 if(success){
  let saved=null;try{saved=JSON.parse(sessionStorage.getItem(key)||'null')}catch{}
  if(saved && saved.sentAt && Date.now()-saved.sentAt<86400000){
   const receipt='FERDORA — Confirmation de transmission de rétractation\n'+saved.text+'\nDate et heure de confirmation : '+success.dataset.received+'\nContact : readyassist@ferdora.com';
   root.querySelector('[data-fd-receipt]').textContent=receipt;
   root.querySelector('[data-fd-no-cache]').hidden=true;
   const download=root.querySelector('[data-fd-download]');download.hidden=false;
   download.addEventListener('click',()=>{const url=URL.createObjectURL(new Blob([receipt],{type:'text/plain;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download='ferdora-confirmation-retractation.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000)});
   try{sessionStorage.removeItem(key)}catch{}
  }
  root.querySelector('[data-fd-print]').addEventListener('click',()=>window.print());
 } else if(form){
  const check=root.querySelector('[data-fd-check]'),send=root.querySelector('[data-fd-submit]'),edit=root.querySelector('[data-fd-edit]'),review=root.querySelector('[data-fd-review]'),fields=root.querySelector('[data-fd-fields]');
  const summary=()=>['Nom : '+form.querySelector('#FerdoraName').value,'E-mail : '+form.querySelector('#FerdoraEmail').value,'Commande / contrat : '+form.querySelector('#FerdoraOrder').value,'Déclaration : '+form.querySelector('#FerdoraBody').value].join('\n');
  check.hidden=false;send.hidden=true;
  check.addEventListener('click',()=>{if(!form.reportValidity())return;root.querySelector('[data-fd-summary]').textContent=summary();review.hidden=false;fields.hidden=true;check.hidden=true;edit.hidden=false;send.hidden=false;send.focus()});
  edit.addEventListener('click',()=>{fields.hidden=false;review.hidden=true;check.hidden=false;edit.hidden=true;send.hidden=true});
  form.addEventListener('submit',()=>{try{sessionStorage.setItem(key,JSON.stringify({text:summary(),sentAt:Date.now()}))}catch{}});
 }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
